<template>
  <div class="results-content-block">
    <not-found v-if="hotels.length === 0 && !searching && !appending">
      <vb-button
        class="not-found__cta"
        v-if="filters_length > 0"
        :vb_options="{
          text: 'Rimuovi tutti i filtri e riprova',
          variant: 'outline-info',
          size: 'sm',
        }"
        @click="reset_filters"
      />
    </not-found>
    <dynamic-scroller
      page-mode
      ref="results-scroller"
      :items="items"
      :item-size="null"
      :min-item-size="100"
      key-field="property_id"
    >
      <template v-slot="{ item, index, active }">
        <dynamic-scroller-item
          class="pb-4"
          :item="item"
          :data-index="index"
          :active="active"
        >
          <component v-if="item.component" :is="item.component" v-bind="item.props" />
          <pad v-else :hotel="item" @toggle-map="toggle_map(item)" />
        </dynamic-scroller-item>
      </template>
    </dynamic-scroller>
  </div>
</template>

<script>
import NotFound from "@/components/blocks/not-found";
import MarketingPad from "@/components/blocks/marketing-pad.vue";
import Pad from "@liveeps/components/blocks/pad.vue";
import { add_extra_components_to_results } from "@/utilities";

export default {
  name: "results-content-block",

  components: {
    "not-found": NotFound,
    "marketing-pad": MarketingPad,
    pad: Pad,
  },

  props: {
    hotels: {
      type: Array,
      default: () => {
        return [];
      },
    },
    searching: Boolean,
    appending: Boolean,
    filters_length: Number,
  },

  data() {
    return {};
  },

  computed: {
    items() {
      return this.add_extra_components_to_results(this.hotels, "property_id");
    },
  },

  created() {},

  mounted() {},

  methods: {
    add_extra_components_to_results,
    reset_filters() {
      this.$emit("reset-filters");
    },

    toggle_map(payload) {
      this.$emit("toggle-map", payload);
    },
  },
};
</script>

<style lang="scss" scoped></style>
